<template>
  <div class="slides box">
    <slider animation="fade" height="100%" :indicators="false" :control-btn="false" :interval="5000" :speed="1">
      <slider-item v-for="item in list" :key="item.id">
        <router-link v-bind:to="item.link()">
          <v-img :src="item.image()"/>
          <div class="title">{{item.title}}</div>
        </router-link>  
      </slider-item>
    </slider>
  </div>
</template>

<script>
  import {Slider, SliderItem} from 'vue-easy-slider'
  import helper from '../helper'
  //import PaperService from "@/services/paper.service";

  export default {
    name: 'vSlider',
    props: {
      data: String
    },
    data() {
      return {
        list: []
      }
    },
    created() {
      this.fetch()
    },
    components: {
      Slider, SliderItem
    },
    methods: {
      fetch() {
        return _.get(this, `$root.$data.${this.data}`).all()
          .filter(p => p.image())
          .then(papers => helper.push(this.list, papers.slice(1)))
      }
    }
  }
</script>

<style scoped lang="stylus">
  .slides
    height 480px
    overflow hidden
    @media screen and (max-width: 480px)
      height 320px
    img
      width 100%
      height auto
      //@media screen and (max-width: 480px)
      //  height 320px
    .title
      text-align left
      position absolute
      bottom 0px
      background rgba(0, 0, 0, .6)
      text-shadow 0 -1px 0 rgba(0, 0, 0, .3)
      width 96%
      padding 2%
      color white
</style>